import PropTypes from "prop-types";

const Category = ({ categoryText, removeCategory, taxonomyCode }) => {
  const onClick = () => removeCategory(taxonomyCode);

  return (
    <div className="search-selection">
      <span className="category">
        {categoryText}{" "}
        <span onClick={onClick} className="pointer">
          &nbsp;X&nbsp;{" "}
        </span>
      </span>
    </div>
  );
};

Category.propTypes = {
  categoryText: PropTypes.string,
  removeCategory: PropTypes.func,
  taxonomyCode: PropTypes.string,
};

export default Category;
